/**
 * Careers template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Careers';

const roleActiveClass = 'careers-opportunities-role--is-expanded';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initCareersOpportunitiesRole();
}

/**
 * initCareersOpportunitiesRole
 */
const initCareersOpportunitiesRole = () => {
	Logger.log(`${NAME} > initCareersOpportunitiesRole`);
	const doms = document.querySelectorAll(`[data-careers-opportunities-role]`);
	if (!doms.length) return;

	doms.forEach(dom => {
		const toggle = dom.querySelector(`[data-careers-opportunities-role-button]`);
		if (!toggle) return;

		const updateAriaExpanded = () => {
			const isExpanded = dom.classList.contains(roleActiveClass);
			toggle.setAttribute('aria-expanded', isExpanded);
		};

		toggle.addEventListener('click', () => {
			dom.classList.toggle(roleActiveClass);
			updateAriaExpanded();
		});

		toggle.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				dom.classList.toggle(roleActiveClass);
				updateAriaExpanded();
			}
		});

		// Set initial state
		updateAriaExpanded();
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
